// extracted by mini-css-extract-plugin
export default {"err_page":"errPage_err_page__pn8iN"};